import { combineReducers } from '@reduxjs/toolkit';
import getSubscriptionPlanListReducer from './get-subscription-plan-list';

const subscriptionPlanReducer = combineReducers({
  getSubscriptionPlanList: getSubscriptionPlanListReducer
});

export default subscriptionPlanReducer;